var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("el-alert", {
        attrs: {
          title: _vm.title,
          type: _vm.type,
          description: _vm.defaultDescription,
          "show-icon": _vm.showIcon,
          closable: _vm.closable,
          center: _vm.center,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }